import Vue from 'vue'

const Event = new Vue()

export default Event
